// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"js9ySK0P6z wrapper","hoursOfOperation":"_3WP1yGBqZc"};


//////////////////
// WEBPACK FOOTER
// ./src/assets/scripts/components/containers/public/legal/Disclosures/Disclosures.module.less
// module id = 966
// module chunks = 3